export type SetScopeAction = { type: 'SET_SCOPE'; userId: string };
export const setScope = (userId: string): SetScopeAction => ({ type: 'SET_SCOPE', userId });

export type SetSearchAction = { type: 'SET_SEARCH'; value: string };
export const setSearch = (value: string): SetSearchAction => ({ type: 'SET_SEARCH', value });

export type StartRouteWriteAction = { type: 'START_ROUTE_WRITE'; routeId: string };
export const startRouteWrite = (routeId: string): StartRouteWriteAction => ({ type: 'START_ROUTE_WRITE', routeId });

export type FinishRouteWriteAction = { type: 'FINISH_ROUTE_WRITE'; routeId: string };
export const finishRouteWrite = (routeId: string): FinishRouteWriteAction => ({
    type: 'FINISH_ROUTE_WRITE',
    routeId,
});

export type StartBulkWriteAction = { type: 'START_BULK_WRITE' };
export const startBulkWrite = (): StartBulkWriteAction => ({ type: 'START_BULK_WRITE' });

export type FinishBulkWriteAction = { type: 'FINISH_BULK_WRITE' };
export const finishBulkWrite = (): FinishBulkWriteAction => ({ type: 'FINISH_BULK_WRITE' });

export type UserRouteEntitlementsAction =
    | SetScopeAction
    | SetSearchAction
    | StartRouteWriteAction
    | FinishRouteWriteAction
    | StartBulkWriteAction
    | FinishBulkWriteAction;
